import { Command, CommandResult } from '@/_core/cqrs/types/commands';

export class UpdateLastSeenBoardActivityId extends Command<CommandResult> {
    constructor(public StorymapId: string, public BoardActivityId: string) {
        super('UpdateLastSeenBoardActivityId');
    }
}
